export default [
  {
    component: () => import("@/components/recebimento/home.vue"),
    name: "recebimento",
    path: "/recebimento",
    label: "Recebimento",
  },
  {
    component: () => import("@/components/recebimento/docsfiscais/home.vue"),
    name: "recebimento.docs",
    path: "/recebimento/docs",
    label: "Documentos Fiscais",
  },
  {
    component: () => import("@/components/compras/compras/gerenciar-notas-importadas-recebimento.vue"),
    name: "recebimento.docs.nfe",
    path: "/recebimento/docs/nfe/gerenciar",
    label: "Visualizar NF-e",
  },
  {
    path: "/recebimento/docs/nfe/importar",
    name: "recebimento.docs.nfe.importar",
    label: "Importar NF-e manualmente",
    component: () => import("@/components/compras/compras/importar-NFe.vue"),
  },
  {
    path: "/recebimento/docs/nfe-industria/:id",
    name: "recebimento.docs.nfe.importada-industria",
    label: "Visualizar Detalhes de NF-e Importadas (Indústria)",
    component: () => import("@/components/recebimento/nota-importada-industria-recebimento.vue"),
  },
  {
    path: "/recebimento/docs/nfe-comercio/:id",
    name: "recebimento.docs.nfe.importada",
    label: "Visualizar Detalhes de NF-e Importadas (Comércio)",
    component: () => import("@/components/compras/compras/nota-importada.vue"),
  },
];
